import { FormControlLabel, FormHelperText, Radio, RadioGroup } from "@mui/material";
import { Controller } from "react-hook-form";

import { FieldShell } from "./FieldShell";
import {
  buildFieldIds,
  getNestedError,
  hasNonEmptyDescription,
  type SchemaFieldProps,
} from "./utils";
import { useTu } from "@src/appV2/i18n/useTu";

export function BooleanField({
  fieldKey,
  property,
  fieldPath,
  isRequired,
  control,
  errors,
}: SchemaFieldProps) {
  const { tu } = useTu("evidence");
  const errorMessage = getNestedError(errors, fieldPath);
  const { description } = property;
  const hasDescription = hasNonEmptyDescription(description);
  const { describedBy } = buildFieldIds(fieldPath, hasDescription);

  return (
    <FieldShell
      fieldKey={fieldKey}
      descriptionId={describedBy}
      isRequired={isRequired}
      description={description}
    >
      <Controller
        name={fieldPath}
        control={control}
        rules={
          isRequired
            ? {
                validate: (value: unknown) =>
                  typeof value === "boolean" || "This field is required",
              }
            : undefined
        }
        defaultValue={undefined}
        render={({ field }) => {
          let valueAsString = "";
          if (field.value === true) {
            valueAsString = "true";
          } else if (field.value === false) {
            valueAsString = "false";
          }

          return (
            <>
              <RadioGroup
                row
                name={field.name}
                value={valueAsString}
                aria-label={fieldKey}
                aria-describedby={describedBy}
                onBlur={field.onBlur}
                onChange={(event) => {
                  field.onChange(event.target.value === "true");
                }}
              >
                <FormControlLabel
                  value="true"
                  control={<Radio inputRef={field.ref} />}
                  label={tu("Yes")}
                />
                <FormControlLabel value="false" control={<Radio />} label={tu("No")} />
              </RadioGroup>
              {errorMessage ? <FormHelperText error>{errorMessage}</FormHelperText> : null}
            </>
          );
        }}
      />
    </FieldShell>
  );
}
